import { useEffect, useRef, useState } from "react";
import { ITeamMast } from "../teamManagement/Table";
import { IUserMast } from "../../models/UserMast";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MoveTeamsForm } from "./MoveTeamsForm";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { MoveTeamsFormMH } from "./MoveTeamsFormMH";

interface IProps {
    singleData: IUserMast,
    open: boolean,
    onHideModuleHeadModal: () => void,
}

export const ModuleHeadTeamManager = (props: IProps) => {
    const [teams, setTeams] = useState<Array<ITeamMast>>();
    const [selectedTeams, setSelectedTeams] = useState<Array<number>>([]);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITeamMast>, loading: boolean });
    const [modal, setModal] = useState({ singleData: [], open: false, userData: {} } as { singleData: ITeamMast[], open: boolean, userData: IUserMast });
    const [moveModal, setMoveModal] = useState({ open: false, team_ID: 0 } as { open: boolean, team_ID: number });
    const [selectedModuleHead, setSelectedModuleHead] = useState([]);
    const [moduleHead, setModuleHead] = useState<Array<IUserMast>>([]);
    const [disableOnSubmitMoveModal, setDisableOnSubmitMoveModal] = useState(false);
    const toast = useRef<any>(null);

    const loadTeam = async () => {
        const response = await Fetch("Dropdown/skillTeams", "GET", null, ``, null);
        if (response) {
            const data: Array<ITeamMast> = await response.json();
            setTeams(data);
        }
    }

    const LoadSavedTeams = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Resource_Management_Team/skillTeams", "GET", null, `Login_Id=${props.singleData.login_ID}`, null);
        if (response) {
            const data: ITeamMast[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const LoadModuleHeads = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("DropDown/moduleHeads", "GET", null, null, null);
        if (response) {
            const data: IUserMast[] = await response.json();
            setModuleHead(data);
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const SaveToDB = async () => {
        if (selectedTeams.length == 0) {
            toast.current.show({ severity: 'error', detail: "Please select atleast one team member", life: 3000 });
        }
        else {
            setLoading(true);
            const response = await Fetch("Resource_Management_Team/addSkillTeams", "POST", selectedTeams, `Login_Id=${props.singleData.login_ID}`, null);
            if (response) {
                const data: any = await response.json();
                if (data.length === 0) toast.current.show({ severity: 'success', detail: "Teams are added", life: 3000 });
                if (data.length > 0) {
                    toast.current.show({ severity: 'success', detail: "Few Teams are added and Some Not", life: 3000 });
                    setModal({ singleData: data, open: true, userData: props.singleData })
                };
                LoadSavedTeams();
                setLoading(false);
                setSelectedTeams([]);
            } else {
                setLoading(false);
            }
        }
    }

    const OnRemove = async (team_ID: number) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Resource_Management_Team/removeTeamList", "DELETE", null, `Login_Id=${props.singleData.login_ID}&team_IDs=${[team_ID]}`, null);
        if (response) {
            toast.current.show({ severity: 'success', detail: "Team Removed", life: 3000 });
            LoadSavedTeams();
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const Remove = (rowData: ITeamMast) => {
        return (
            <div className="flex gap-3">
                <Button className="w-6rem h-2rem" onClick={() => OnRemove(rowData.team_ID ? rowData.team_ID : 0)}>REMOVE</Button>
                <Button className="w-6rem h-2rem" onClick={() => setMoveModal({ open: true, team_ID: rowData.team_ID ? rowData.team_ID : 0 })}>MOVE</Button>
            </div>
        );
    }

    const onMove = async () => {
        setDisableOnSubmitMoveModal(true);
        const response = await Fetch("Resource_Management_Team/removeTeamList", "DELETE", null, `Login_Id=${selectedModuleHead}&team_IDs=${[moveModal.team_ID]}`, null);
        if (response) {
            const resp = await Fetch("Resource_Management_Team/addSkillTeams", "POST", [moveModal.team_ID], `Login_Id=${selectedModuleHead}`, null);
            if (resp) {
                const data: any = await resp.json();
                if (data.length === 0) toast.current.show({ severity: 'success', detail: "Teams is moved", life: 3000 });
                if (data.length > 0) {
                    toast.current.show({ severity: 'error', detail: "Team can not be moved", life: 3000 });
                };
                LoadSavedTeams();
                setLoading(false);
                setDisableOnSubmitMoveModal(false);
                setMoveModal({ open: false, team_ID: 0 });
            } else {
                setLoading(false);
                setDisableOnSubmitMoveModal(false);
            }
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
            setDisableOnSubmitMoveModal(false);
        }
    }

    const OnHide = () => {
        setSelectedTeams([]);
        setLoading(false);
        props.onHideModuleHeadModal();
    }

    useEffect(() => {
        if (props.open) {
            LoadSavedTeams();
            loadTeam();
            LoadModuleHeads();
        }
    }, [props.open]);
    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Allocated Teams" modal className="p-fluid" onHide={OnHide} >
                <MultiSelect value={selectedTeams} options={teams} onChange={(e) => setSelectedTeams(e.value)} optionValue="team_ID" optionLabel="team_Name" display="chip" filter placeholder="Select Teams" maxSelectedLabels={10} className="w-11" />
                <div className="flex flex-row-reverse">
                    <Button loading={loading} className="h-2rem mt-5 w-6rem" onClick={SaveToDB}>SUBMIT</Button>
                </div>

                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                    size="small"
                    value={tableData.tableData} lazy dataKey="id"
                    emptyMessage="No Users found."
                    header={""}
                    loading={tableData.loading}
                >
                    <Column field="team_Name" header="Team Name" />
                    <Column field="" header="Action" body={Remove} />
                </DataTable>
            </Dialog>
            <MoveTeamsFormMH open={modal.open} login_ID={props.singleData.login_ID || 0} singleData={modal.singleData} setModal={setModal} userData={modal.userData} LoadSavedTeams={LoadSavedTeams} />
            <Dialog visible={moveModal.open} style={{ width: '30vw' }} header="Move To Another Module Head" modal className="p-fluid" onHide={() => {
                setMoveModal({ open: false, team_ID: 0 });
                setSelectedModuleHead([]);
            }}>
                <div className="flex w-full justify-content-between">
                    <Dropdown showClear value={selectedModuleHead} onChange={(e) => setSelectedModuleHead(e.value)} options={moduleHead} optionLabel="user_Name" optionValue="login_ID" placeholder="Select a Module Head" className="w-full md:w-14rem" />
                    <Button className="w-5rem" disabled={disableOnSubmitMoveModal} onClick={onMove}>Move</Button>
                </div>
            </Dialog>
            <Toast ref={toast} />
        </>
    );
}